<template>
    <v-layout wrap v-if="pillList && pillList.length > 0" class="filter-pills-list">
        <community-filter-pill v-for="(filter, index) in pillList"
                           class="filter-pills-list__item"
                           :filter-index="index"
                           :handle-close="pillList.length > 1 ? handleClose : handleClear"
                           :key="index"
                           :pill-item="filter">
        </community-filter-pill>
        <v-flex class="filter-pills-list__clear-all pointer" @click="handleClear"
                data-qe-id="community-directory-filter_clear-all_button">
            <span><v-icon color="black" size="18">close</v-icon></span>
            <span class="filter-pills-list__clear-all-label">{{communityDirectoryPageConstant.label.CLEAR_ALL}}</span>
        </v-flex>
    </v-layout>
</template>
<script>
    import CommunityFilterPill from "./CommunityFilterPill";
    import { communityDirectoryPageConstant } from "./communityDirectoryPage.constants";
    import { sortListAlphabeticallyAsc } from "@/components/EventDirectoryPage/eventDirectoryPage.constants";

    export default {
        name: 'CommunityFilterPillsList',
        components: {
            CommunityFilterPill,
        },
        data() {
            return {
                communityDirectoryPageConstant,
            };
        },
        props: {
            communitySelectedFilters: {
                type: Object,
                required: true,
            },
            handleClose: {
                type: Function,
                required: true,
            },
            handleClear: {
                type: Function,
                required: true,
            },
        },
        computed: {
            pillList() {
                const pills = [];
                if (this.communitySelectedFilters) {
                    Object.keys(this.communitySelectedFilters).forEach((key) => {
                        if (this.communitySelectedFilters.hasOwnProperty(key) && key.length > 0) {
                            pills.push(...sortListAlphabeticallyAsc(this.communitySelectedFilters[key]));
                        }
                    });
                }
                return pills;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    .filter-pills-list {
        padding: 15px 0;

        &__item {
            margin-right: 10px;
            margin-bottom: 15px;
        }

        &__clear-all {
            background-color: $white;
            flex: 0 1 auto !important;
            padding: 5px 10px;

            &-label {
                padding-left: 5px;
                color: $ypo-cta;
            }
        }
    }

</style>
